// Canonical list of toggleable sidebar modules for customers.
// Ids must match the Sidebar NAV item ids and the App PAGES map.
// Admin-only items (e.g. the Admin Portal) are never in this list.
export const CUSTOMER_MODULES = [
  { id: 'dashboard',      label: 'Dashboard' },
  { id: 'analytics',      label: 'Analytics' },
  { id: 'callquality',    label: 'Teams Call Quality' },
  { id: 'users',          label: 'User Directory' },
  { id: 'callqueues',     label: 'Call Queues' },
  { id: 'autoattendants', label: 'Auto Attendants' },
  { id: 'numbers',        label: 'Number Inventory' },
  { id: 'voxbone',        label: 'Number Routing' },
  { id: 'bwrouting',      label: 'BW Number Routing' },
  { id: 'platforms',      label: 'UC / CC Platforms' },
  { id: 'sites',          label: 'Sites' },
  { id: 'alerts',         label: 'Alerts' },
  { id: 'settings',       label: 'Settings' },
  { id: 'security',       label: 'Security & Compliance' },
];

export const CUSTOMER_MODULE_IDS = CUSTOMER_MODULES.map(m => m.id);
